/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2LeftArrowLongCircle/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2LeftArrowLongCircle({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2LeftArrowLongCircle",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2LeftArrowLongCircle.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-ir4bg': alignSelf,'--mt-2-ir4bg': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ir4bg': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ir4bg': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ir4bg': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ir4bg': opacity,'--w-10-ir4bg': typeof width === 'number' ? `${width}px` : width,'--h-11-ir4bg': typeof height === 'number' ? `${height}px` : height,'--f-12-ir4bg': fill,'--a-7-ir4bg': isAnimated ? animation : "none",'--sd-8-ir4bg': isAnimated ? strokeDashoffset : 0,'--sd-9-ir4bg': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2LeftArrowLongCircle.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_5304_5387)"
 className="views-block"
>
<path
  data-testid="Tysiav2LeftArrowLongCircle.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M14 7A7 7 0 100 7a7 7 0 0014 0zM7.47 3.47a.75.75 0 011.06 1.06L6.06 7l2.47 2.47a.75.75 0 11-1.06 1.06l-3-3a.75.75 0 010-1.06l3-3z"
 style={{'--f-12-ir4bg': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}